window.en_dic = {
    'plan': 'Plan',
    'common.calendar.january': 'January',
    'common.calendar.february': 'February',
    'common.calendar.march': 'March',
    'common.calendar.april': 'April',
    'common.calendar.may': 'May',
    'common.calendar.june': 'June',
    'common.calendar.july': 'July',
    'common.calendar.august': 'August',
    'common.calendar.september': 'September',
    'common.calendar.october': 'October',
    'common.calendar.november': 'November',
    'common.calendar.december': 'December',
    'common.calendar.sunday.short': 'Sun',
    'common.calendar.monday.short': 'Mon',
    'common.calendar.tuesday.short': 'Tue',
    'common.calendar.wednesday.short': 'Wed',
    'common.calendar.thursday.short': 'Thu',
    'common.calendar.friday.short': 'Fri',
    'common.calendar.saturday.short': 'Sat',
    'common.label.roomCount': 'rooms',
    'common.label.mailAddressEmptyError': 'Please enter your e-mail address.',
    'common.label.mailAddressCharacterCountError': 'Please enter your email address within 254 characters.',
    'common.label.mailAddressIncorrectError': 'Please enter the correct email address.',
    'GCER001F00100.label.countryCodeEmptyError': 'Please enter your phone number (country code).',
    'GCER001F00100.label.countryCodeCharacterCountError': 'Please enter the phone number (country code) within 5 characters.',
    'GCER001F00100.label.countryCodeIncorrectError': 'Please enter the correct phone number (country code).',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin5': 'Please enter the phone number (area code) within 5 characters.',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin9': 'Please enter the phone number (area code) within 9 characters.',
    'common.label.areaCodeIncorrectError': 'Please enter the correct phone number (area code).',
    'common.label.cityCodeCharacterCountErrorWithin4': 'Please enter the phone number (city code) within 4 characters.',
    'GCER001F00100.label.cityCodeCharacterCountErrorWithin9': 'Please enter the phone number (city code) within 9 characters.',
    'common.label.cityCodeIncorrectError': 'Please enter the correct phone number (city code).',
    'common.label.subscriberNumberCharacterCountErrorWithin4': 'Please enter the phone number (subscriber number) within 4 characters.',
    'GCER001F00100.label.subscriberNumberCharacterCountErrorWithin9': 'Please enter the phone number (subscriber number) within 9 characters.',
    'common.label.subscriberNumberIncorrectError': 'Please enter the correct phone number (subscriber number).',
    'GCER001F00100.label.areaCodeEmptyError': 'Please enter your phone number (area code).',
    'GCER001F00100.label.cityCodeEmptyError': 'Please enter the phone number (city code).',
    'GCER001F00100.label.subscriberNumberEmptyError': 'Please enter your phone number (subscriber number).',
    'common.label.reservationNumberEmptyError': 'Please enter your reservation number.',
    'common.label.reservationNumberCharacterCountError': 'Please enter the reservation number within 19 characters.',
    'common.label.passwordEmptyError': 'Please enter your password.',
    'common.label.passwordCharacterCountError': 'Enter the password using up to 64 characters.',
    'common.label.authenticationError': 'An error occurred when executing authentication. Please reload the authentication screen and perform authentication again.',
    'common.label.snsAuthenticationFail': 'SNS authentication failed.',
    'GCER001F00100.label.failSnsLogin': 'Failed to log in to SNS.',
    'GCER001F00100.label.areaCodeCharacterCountErrorWithin3': 'Please enter the phone number (area code) within 3 characters.',
    'common.label.unexpectedLoginError': 'An unexpected error occurred during login.',
    'common.label.sun': 'Sun',
    'common.label.mon': 'Mon',
    'common.label.tue': 'Tue',
    'common.label.wed': 'Wed',
    'common.label.thu': 'Thu',
    'common.label.fri': 'Fri',
    'common.label.sat': 'Sat',
    'common.label.gender.male': 'Male',
    'common.label.gender.female': 'Female',
    'common.label.gender.other': 'Other',
    'common.label.adult': 'Adults',
    'common.label.guestCount': 'guests',
    'common.label.comma': ', ',
    'common.label.others': 'others',
    'common.label.yen': 'yen',
    'common.label.paymentFailMessage': 'Payment failed. Please contact your system administrator.',
    'common.label.mailAddressIncorrectFormatError': 'Please enter your email address in the correct email address format.',
    'common.label.welcomeInformation1-1': 'A welcome email is an email that reminds you of ',
    'common.label.welcomeInformation1-2': 'your reservation one week before your stay.',
    'common.label.welcomeInformation2': '* However, a similar email will be sent 3 days before your stay.',
    'common.label.welcomeInformation3': 'Please note that your email will always be sent to you.',
    'common.label.thankYouInformation': 'Thank you email is an email sent after your stay.',
    'common.label.chargeDetails': 'Charge details',
    'common.label.nightNumber': 'night',
    'common.label.roomNumber': 'room',
    'common.label.memberDiscount': 'Member discount',
    'common.label.subtotal': 'subtotal',
    'common.label.totalRoomRate': 'Total',
    'common.label.pointYenEquivalent': 'Points',
    'common.label.pointBalanceAmount': 'Available points',
    'common.label.usableMaxLimit.point': 'Maximum points available：{0}',
    'common.label.usableMinLimit.point': 'Minimum points available：{0}',
    'common.label.usableRange.point': '{0}-{1} points are available.',  
    'common.label.usableUnit.point': '(Unit of point use：{0})',
    'common.label.usableUnit.point.help': 'Can be used in units of {0} points.',
    'common.label.pointToGrantSuffix.point': '{0} points',
    'common.label.use': 'Use',
    'common.label.useAll': 'Use all',
    'coupon.message.applyCode' : 'Additional coupons.',
    'coupon.message.getCoupon' : 'got a coupon.',
    'coupon.message.getCoupon.failed' : 'Could not get coupon.',
    'GRES006F02600.label.lodgingNumChangeCautionWord': '* The number of people cannot be added. If you want to add it, please make a reservation again.',
    'GRES006F02600.label.lodgingNumPriceEmptyCautionWord': 'We do not accept reservations for the total number of guests you specified.',
    'GRES006F02600.label.lodgingDateNumChangeCautionWord': '* You cannot increase the number of nights. If you want to increase it, please make a reservation again.',
    'GRES006F02600.label.optionChangeWord': '* Cannot be selected because it is outside the reservation acceptance period',
    'GRES006F02600.label.kanaInformation': 'Please enter in hiragana.',
    'GRES006F02600.label.mailInformation1': 'Please enter the same email address in two places to prevent typos.',
    'GRES006F02600.label.mailInformation2': 'If you enter your mobile email address, please be careful about your email filter settings.',
    'GRES006F02600.label.mailInformation3': 'If you are set to not be able to receive emails from the Internet, you will not be able to receive emails confirming your reservation.',
    'GRES006F02600.label.contactInformation': 'Please enter only half-width numbers.',
    'common.label.addressZipMark': '',
    'GRES015F04300.label.reservationAcceptanceSuspension': 'Im sorry. Currently, we are not accepting reservations.',
    'GRES015F04300.label.planAcceptanceSuspension': 'Im sorry. Currently, we are not accepting the specified plan.',
    'GRES015F04300.label.roomAcceptanceSuspension': 'Im sorry. Currently, the reception of the designated room is closed.',
    'GRES001F02100.label.returnPlanList' : 'Return to plan list',
    'GRES001F02100.validation.emptyNameError' : 'Your name is required. Please enter it.',
    'GRES001F02100.validation.wrongNameError' : 'Please exclude special symbols and environment-dependent.',
    'GRES001F02100.validation.emptyNameKanaError' : '',
    'GRES001F02100.validation.wrongNameKanaError' : '',
    'GRES001F02100.validation.emptyMailAddressError' : 'Email address is required. Please enter it.',
    'GRES001F02100.validation.wrongMailAddressError' : 'Please enter in a valid format.',
    'GRES001F02100.validation.emptyMailAddressConfirmError' : 'Email address is required. Please enter it.',
    'GRES001F02100.validation.unmatchMailAddressConfirmError' : 'Please enter a matching email address.',
    'GRES001F02100.validation.emptyTelError' : 'Phone number is required. Please use half-width numbers.',
    'GRES001F02100.validation.wrongTelError' : 'Please use half-width digit.',
    'GRES001F02100.validation.tooShortTelAreaError' : 'Please enter the area code with 2-5 single-byte numbers.',
    'GRES001F02100.validation.tooLongTelError' : 'Please enter 7-15 single-byte numbers.',
    'GRES001F02100.validation.emptyLodgerGender' : 'Gender is required. Please select one.',
    'GRES001F02100.validation.emptyPassword' : 'Your password is required. Please set 8 to 64 half-width alphanumeric characters (including uppercase and lowercase letters).',
    'GRES001F02100.validation.wrongPassword' : 'Please set 8 to 64 half-width alphanumeric characters (including uppercase and lowercase letters).',
    'GRES001F02100.validation.emptyBirthday' : 'Date of birth is required. Please select one.',
    'GRES001F02100.validation.notRequiredEmptyBirthday' : 'Please select your date of birth.',
    'GRES001F02100.validation.emptyZipCode' : 'Zip code is required. Please enter it.',
    'GRES001F02100.validation.wrongZipCode' : 'Please enter in single-byte number.',
    'GRES001F02100.validation.emptyAddressPrefectures' : 'Address is required.',
    'GRES001F02100.validation.emptyAddress' : 'Address is required. Please enter it.',
    'GRES001F02100.validation.emptyCreditCardNo' : 'Credit card number is required. Please enter 14-16 half-width numbers.',
    'GRES001F02100.validation.wrongCreditCardNo' : 'Please enter 14_16 half-width numbers.',
    'GRES001F02100.validation.emptySecurityCode' : 'Security code is required. Please enter 3 or 4 single-byte digits.',
    'GRES001F02100.validation.wrongSecurityCode' : 'Please enter 3 or 4 single-byte digits.',
    'GRES001F02100.validation.emptyCreditCardName' : 'Account holder\'s name is required. Please enter it.',
    'GRES001F02100.validation.wrongCreditCardName' : 'Please enter the account holder\'s name in a valid format.',
    'GRES001F02100.validation.emptyCreditCardExpire' : 'Card expiration date is required. Please select one.',
    'GRES001F02100.validation.wrongCreditCardExpire' : 'A past date has been selected. Please select a future date.',
    'GRES001F02100.validation.tooLongTextArea' : 'Please enter within 200 characters.',
    'GRES001F02100.validation.emptyContractCompany' : 'This field is required. Please enter it.',
    'GRES001F02100.validation.emptyContractCompanyPassword' : 'Your password is required. Please enter it.',
    'GRES001F02100.validation.wrongContractCompanyPassword' : 'Please enter half-width alphanumeric symbols.',
    'GRES001F02100.validation.unmatchLodgerGender' : 'Please select the number of guests per gender according to your reservation.',
    'GRES001F02100.validation.emptyQuestionTextAnswer' : 'This field is required. Please enter it.',
    'GRES001F02100.validation.tooLongQuestionTextAnswer' : 'Please enter within 200 characters.',
    'GRES001F02100.validation.emptyQuestionSelectAnswer' : 'This field is required. Please select one.',
    'GRES001F02100.validation.emptyQuestionCheckboxAnswer' : 'This field is required. Please select one.',
    'GRES001F02100.validation.couponCodeError' : 'Coupon for the entered code cannot be found. Please check the details you entered.',
    'GRES001F02100.validation.couponCodeDuplicatedError' : 'Coupons already added.',

    'coupon.label.more': 'More info.▼',
    'coupon.label.close': 'More info.▲',

    'coupon.banner.title.member': 'Register as a member',
    'coupon.banner.title': 'to save on reservations with discount coupons!',
    'coupon.banner.title.button': 'More info ▶',
    'coupon.modal.title': 'Register as a member to benefit from special coupons',
    'coupon.modal.title.member': 'List of coupons being distributed',
    'coupon.modal.caution': 'Each coupon has its own conditions for get and use.',
    'coupon.modal.desc.1': 'The coupon discount applies to the room rate. The discount does not apply to additional optional charges.',
    'coupon.modal.desc.2': 'The coupons you have earned are automatically applied to the best deals and combinations at the time of booking.',
    'coupon.modal.desc.3': 'Coupons may end early if the planned number of coupons to be distributed ends or for budgetary or other reasons.',
    'coupon.modal.desc.4': 'Depending on the timing of the booking, it may not be available even if already earned.',
    'coupon.modal.membership': 'If you are already registered',
    'coupon.modal.memberLogin': 'Log in',
    'coupon.modal.memberRegister': 'Register as a member',
    'coupon.modal.has.otherCoupons': 'Coupons available for other dates',
    'coupon.badge.couponTarget': 'Coupon Eligibility',
    'coupon.badge.banner.title': 'Get the best coupons',

    'coupon.label.code': '（{{code}}）',
    'coupon.label.discountAmount.upper': 'From the total of the booking',
    'coupon.label.discountAmount.upper_false': 'Per person or per room',
    'coupon.label.discountAmount': '{{amount, number}}yen discount',
    'coupon.label.discountAmount_rate': '{{amount, number}}% discount',
    'coupon.label.discountAmount.has.zeroDiscount': 'Benefit',
    'coupon.label.canUseTogether_true': 'Can be used in conjunction with other coupons',
    'coupon.label.canUseTogether_false': 'Not valid in conjunction with other coupons',
    'coupon.label.discountLimit': 'Max. discount is {{amount, number}}yen.',
    'coupon.label.discountLimit_plan': 'Max. discount is {{amount, number}}yen per person per night.',
    'coupon.label.fromTotalBookings.not': '* Depending on the plan, the discount is from the per person per night rate or from the per room per night rate.',
    'coupon.label.useQuantityLimit': 'First-come, first-served up to {{amount, number}}copies',
    'coupon.label.targetPlans': 'Eligible plans:',
    'coupon.label.availableMonths': '{{months}} months from acquisition',
    'coupon.label.expiredAt': 'Expiry date:',
    'coupon.label.neverExpires': 'No expiry date',
    'coupon.label.stayAt': 'Period of stay:',
    'coupon.label.periodRange': '{{- day.start}}～{{- day.end}}',
    'coupon.label.periodRangeCheck': '{{- day.start}} check-in to {{- day.end}} check-out',
    'coupon.label.unavailableDays': 'Excluded days:',
    'coupon.label.unavailablePeriod': 'Excluding periods:',
    'coupon.label.useCondition': 'Available for bookings over {{amount, number}}yen',
    'coupon.label.remainingTimes': 'Can be used up to {{amount, number}}times （remaining{{remains, number}}times）',
    'coupon.label.remainingTimes.limit': 'Can be used up to {{amount, number}}times',
    'coupon.label.remainingTimes.one': 'Available only once',
    'coupon.label.remainingTimes.noLimit': 'Available as many times as you like',
    'coupon.label.acquired': 'already acquired',
    'coupon.label.acquiring': 'Get',
    'coupon.message.unable.useAmountLimit' : 'Not available as the campaign has ended.',
    'coupon.message.unable.useQuantityLimit' : 'Not available as the campaign has ended.',
    'coupon.message.unable.ended' : 'Not available as the campaign has ended.',
    'coupon.message.unable.notApplied' : 'Cannot be used in conjunction with coupons scheduled to be used.',

    'common.message.temporaryError': 'A temporary error has occurred. Please reload the page to refresh.',
    'common.label.required': 'Required',
};
